import React from "react";
import Button from "../../Button";
import pareja3 from "../../../assets/pareja3.png";
import beneficios from "../../../assets/beneficios.png";
import { useNavigate } from "react-router-dom";

const SimuladorPersonas = () => {
    const navigate = useNavigate();
    
    const scrollToTopAndNavigate = (path) => {
        window.scrollTo({ top: 0, behavior: "instant" });
        navigate(path);
    };

    return (
        <section className="bg-[#EAF4F8] px-6 sm:px-10 lg:px-12 py-10 xl:py-0 xl:h-[500px] overflow-hidden flex flex-col gap-10 xl:grid xl:grid-cols-6">
            <div className="xl:col-span-3 text-center xl:text-left flex flex-col justify-center gap-4">
                <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-[#0047ab]">¡No te compliques!</h1>
                <p className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-[#0047ab]">
                    Haz todo desde un mismo lugar, compara, adquiere y centraliza tus productos financieros.
                </p>
            </div>

            <div className="xl:col-span-2 relative flex flex-col items-center justify-center">
                <img
                    src={beneficios}
                    alt="Beneficios"
                    className="w-full max-w-sm sm:max-w-lg xl:max-w-none xl:absolute xl:left-[-30%] xl:h-full object-contain opacity-70 xl:opacity-100"
                />

                <div className="flex xl:absolute xl:left-0 xl:ml-16 flex-col gap-6 sm:gap-8 xl:gap-10 mt-8 xl:mt-0 w-full max-w-xs sm:max-w-sm">
                    <Button text="Simula MiFIC" color="bg-[#2eab0e]" textColor="text-white" paddingX="px-8" paddingY="py-3" rounded="rounded-3xl" onClick={() => scrollToTopAndNavigate("/personas/misFICs")} />
                    <Button text="Simula MiCDT" color="bg-[#2eab0e]" textColor="text-white" paddingX="px-8" paddingY="py-3" rounded="rounded-3xl" onClick={() => scrollToTopAndNavigate("/personas/simula-tu-cdt")} />
                    <Button text="Simula MiPensión" color="bg-[#2eab0e]" textColor="text-white" paddingX="px-8" paddingY="py-3" rounded="rounded-3xl" onClick={() => scrollToTopAndNavigate("/personas/miPension")} />
                </div>
            </div>
            <div className="xl:col-span-1 relative flex flex-col items-center xl:items-end justify-end gap-4">
                <img src={pareja3} alt="Pareja" className="w-40 sm:w-56 xl:w-auto xl:scale-125" />
                <p className="text-blue-700 font-bold text-sm sm:text-base text-center xl:text-left max-w-xs">
                    María y Pablo lograron financiar la educación de sus hijos ahorrando $1,000,000 al mes con MEU.
                </p>
            </div>
        </section>
    );
};

export default SimuladorPersonas;
